<template>
  <v-dialog
    v-if="isDataLoadedFromServer"
    v-model="dialog"
    persistent
    transition="dialog-bottom-transition"
    max-width="600"
  >
    <!--begin::Modal dialog-->
    <div class="bg-white poppins">
      <!--begin::Modal header-->
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">Add New Record</h4>
        <!--begin::Close-->
        <div
          class="btn btn-sm btn-icon btn-active-light-info"
          @click="toggleModal"
        >
          <span class="svg-icon">
            <v-icon size="22">mdi-close</v-icon>
          </span>
        </div>
        <!--end::Close-->
      </div>
      <!--end::Modal header-->
      <!--begin::Modal body-->
      <div
        class="modal-body d-flex flex-column h-450px scroll-y mx-5 mx-xl-15 py-7"
      >
        <div class="h-75px">
          <v-autocomplete
            v-model="formData.organizations"
            dense
            label="Organization"
            item-text="text"
            item-value="index"
            :items="serverData.organizations"
            clearable
            outlined
            hide-details
          ></v-autocomplete>
        </div>

        <div class="h-75px">
          <v-autocomplete
            v-model="formData.action_flows"
            dense
            label="Action flows"
            item-text="text"
            item-value="index"
            :items="serverData.action_flows"
            clearable
            outlined
            hide-details
          ></v-autocomplete>
        </div>

        <div class="h-75px">
          <v-autocomplete
            v-model="formData.systems"
            dense
            label="Systems"
            item-text="text"
            item-value="index"
            :items="serverData.systems"
            clearable
            outlined
            hide-details
          ></v-autocomplete>
        </div>

        <div class="h-75px">
          <v-autocomplete
            v-model="formData.integration_types"
            dense
            label="Integration type"
            item-text="text"
            item-value="index"
            :items="serverData.integration_types"
            clearable
            outlined
            hide-details
          ></v-autocomplete>
        </div>

        <!--begin::Actions-->
        <div class="mb-4 d-flex flex-grow-1 align-end justify-center">
          <button
            type="reset"
            class="btn btn-light mr-3 px-5 py-3 ls1"
            @click="resetCreateForm"
          >
            Clear
          </button>
          <button
            type="submit"
            class="btn btn-info px-5 py-3 ls1"
            @click="submitCreateForm"
          >
            Submit
          </button>
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Modal body-->
    </div>
    <!--end::Modal dialog-->
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";
import Swal from "sweetalert2";

export default {
  name: "AddItem",
  props: ["refresher", "pageLoader"],
  data: () => ({
    dialog: false,
    serverData: {
      organizations: null,
      action_flows: null,
      systems: null,
      integration_types: null,
    },
    formData: {
      organizations: null,
      action_flows: null,
      systems: null,
      integration_types: null,
    },
  }),
  beforeMount() {
    this.loadDataFromServer();
  },
  methods: {
    loadDataFromServer() {
      this.pageLoader(true);
      ApiService.post("/organization/organizationActionFlow/create")
        .then((response) => {
          this.serverData = response.data;
          this.pageLoader(false);
        })
        .catch(() => {
          this.dialog = false;
          this.pageLoader(false);
        });
    },

    toggleModal() {
      if (this.dialog) {
        this.resetCreateForm();
      }
      this.dialog = !this.dialog;
    },
    submitCreateForm() {
      this.pageLoader(true);
      ApiService.post(
        "/organization/organizationActionFlow/store",
        this.formData
      )
        .then(() => {
          Swal.fire({
            title: "Created",
            text: `Record has been successfully added!`,
            icon: "success",
            showConfirmButton: false,
            timer: 2500,
          });
          this.toggleModal();
          this.refresher();
        })
        .catch(() => {
          this.pageLoader(false);
        });
    },
    resetCreateForm() {
      this.formData = {
        organizations: null,
        action_flows: null,
        systems: null,
        integration_types: null,
      };
    },
  },
  computed: {
    isDataLoadedFromServer: function () {
      return !!this.serverData;
    },
  },
};
</script>
